<!--
 * @Author: Ashley.Liu
 * @Date: 2022-05-05 16:12:18
 * @LastEditTime: 2022-08-10 14:59:33
 * @Description: desc
-->
<template>
  <div class="app-main">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'AppMain'
}
</script>

<style scoped>
.app-main {
  /*84 = navbar + tags-view = 50 +34 */
  display: block;
  width: 100%;
  position: relative;
  padding-bottom: 40px;
}
</style>
